import { loan_application } from '@axo/shared/data-access/types';

type GetTotalRefinanceAmount = {
  debts?: Partial<loan_application.Debt>[];
};

export const getTotalRefinanceAmount = ({ debts }: GetTotalRefinanceAmount) => {
  if (!debts || debts.length === 0) return 0;

  return debts.reduce((acc, debt) => {
    if (!debt.RefinanceAmount) return acc;

    return acc + debt.RefinanceAmount;
  }, 0);
};
